import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/app.css";
import kzLocale from "@/lang/kz.json";
import ruLocale from "@/lang/ru.json";
import enLocale from "@/lang/en.json";

Vue.config.productionTip = false;

const locales = {
  kz: kzLocale.data,
  ru: ruLocale.data,
  en: enLocale.data,
};

let currentLang = localStorage.getItem("lang") || "ru";
if (!["kz", "ru", "en"].includes(currentLang)) {
  currentLang = "ru";
  localStorage.setItem("lang", "ru");
}

Vue.mixin({
  methods: {
    __(key) {
      const langKey = localStorage.getItem("lang");
      const dictionary = locales[langKey] || locales["ru"];

      return (
        key
          .split(".")
          .reduce(
            (a, b) => (a ? a[b] : undefined), 
            dictionary
          ) ?? "Перевод отсутствует"
      );
    },
  },
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
